import { lazy } from "react";

const CreateEdit = lazy(() =>
  import("../../pages/UserAccess/RoleAccessProfileMapping/create-edit"),
);

const routes = [
  {
    path: "/role_access_profile_mapping",
    element: lazy(() =>
      import("../../pages/UserAccess/RoleAccessProfileMapping/index"),
    ),
  },
  {
    path: "/role_access_profile_mapping/add",
    element: CreateEdit,
  },
  {
    path: "/role_access_profile_mapping/edit/:roleId",
    element: CreateEdit,
  },
];

export default routes;
